/**
 * Left-click on the handle opens the menu. A drag is left for the node.
 */

import { useCallback, useEffect, useRef } from 'react';

const MENU_HEIGHT = 350;
const MENU_WIDTH = 180;

export function useHandleClick({ handleRef, setShowMenu, setMenuPosition }) {
  const clickStartRef = useRef(null);
  const isTrackingRef = useRef(false);

  const handleDocumentMouseUp = useCallback((e) => {
    if (!clickStartRef.current || !isTrackingRef.current) return;

    if (e.button !== 0) {
      clickStartRef.current = null;
      isTrackingRef.current = false;
      return;
    }

    const deltaX = Math.abs(e.clientX - clickStartRef.current.x);
    const deltaY = Math.abs(e.clientY - clickStartRef.current.y);
    const deltaTime = Date.now() - clickStartRef.current.time;

    if (deltaX < 5 && deltaY < 5 && deltaTime < 300 && handleRef.current) {
      const rect = handleRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      let top = rect.top;
      if (top + MENU_HEIGHT > viewportHeight) {
        top = viewportHeight - MENU_HEIGHT - 10;
      }

      let left = rect.left - MENU_WIDTH;
      if (left < 10) {
        left = rect.right + 8;
      }

      setMenuPosition({ top, left });
      setShowMenu(prev => !prev);
    }

    clickStartRef.current = null;
    isTrackingRef.current = false;
  }, [handleRef, setMenuPosition, setShowMenu]);

  useEffect(() => {
    document.addEventListener('mouseup', handleDocumentMouseUp);
    return () => {
      document.removeEventListener('mouseup', handleDocumentMouseUp);
    };
  }, [handleDocumentMouseUp]);

  const handleMouseDown = (e) => {
    if (e.button !== 0) return;
    clickStartRef.current = { x: e.clientX, y: e.clientY, time: Date.now() };
    isTrackingRef.current = true;
  };

  return { handleMouseDown };
}
